// src/pages/unauthorized/Unauthorized.js
import React from 'react';
import { useTranslation } from 'react-i18next';

const Unauthorized = () => {
  const { t } = useTranslation();

  return (
    <div>
      <h1>{t('unauthorizedPage.title')}</h1>
      <p>{t('unauthorizedPage.message')}</p>
    </div>
  );
};

export default Unauthorized;
